import { type ComponentPropsWithoutRef } from 'react';

export interface LoadingScreenProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  /** Additional CSS classes */
  className?: string;
}

/**
 * LoadingScreen - Centered progress bar for lazy loading states
 * Used as Suspense fallback for dashboard and content pages
 * Lighter weight than SplashScreen (no animated logo)
 */
export function LoadingScreen({ className = '', ...other }: LoadingScreenProps) {
  return (
    <div
      className={`flex min-h-screen items-center justify-center bg-tkf-surface-page ${className}`}
      {...other}
    >
      {/* eslint-disable-next-line no-restricted-syntax -- spinner container, no flow wrapper */}
      <div className="w-full max-w-[360px] px-4">
        <div className="h-1 w-full overflow-hidden rounded-full bg-tkf-line">
          <div className="h-full w-full origin-left animate-[loading_1.5s_ease-in-out_infinite] bg-primary-500" />
        </div>
      </div>
      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(0%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
